/**
 * Copyright © 2024 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { ZONE_FRAGMENT } from '../fragments/ZoneFragment'

export const GET_ZONES = gql`
  query GetZones($input: ZonesInput) {
    filteredZones(input: $input) {
      ...Zone
    }
  }
  ${ZONE_FRAGMENT}
`
